<template>
  <b-row>
    <b-col cols="6">
      <BfInput
        label="Código postal*"
        data-key="codigopostal"
        :value="data.codigopostal"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="6">
      <BfInput
        label="Población*"
        data-key="poblacion"
        :value="data.poblacion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="6">
      <BfInput
        label="Municipio*"
        data-key="municipio"
        :value="data.municipio"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="6">
      <BfInput
        label="Provincia*"
        data-key="provincia"
        :value="data.provincia"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="12">
      <BfSelect
        label="Zona*"
        data-key="zonas_id"
        :options="zonasSelector"
        :value="data.zonas_id"
        :errors="errors"
        @update="updateForm"
        :clearable="true"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'codigoPostalForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
    zonasSelector: {
      type: Array,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData)
    },
    updateCp(fieldData) {
      this.$emit('updatecp', fieldData)
    },
  },
}
</script>
